import type { ReactNode } from 'react';

type StatRowTone = 'default' | 'muted' | 'highlight';

const VALUE_TONE_CLASSES: Record<StatRowTone, string> = {
    default: 'text-zinc-200',
    highlight: 'font-medium text-white',
    muted: 'text-zinc-400'
};

interface StatRowProps {
    label: ReactNode;
    value: ReactNode;
    tone?: StatRowTone;
    className?: string;
}

/**
 * Single label/value summary row for stat panels (e.g. Run Summary cards).
 * Compose inside a StatList or any space-y container.
 */
export const StatRow = ({ label, value, tone = 'default', className = '' }: StatRowProps) => (
    <div className={`flex items-baseline justify-between gap-3 text-sm ${className}`}>
        <span className="text-zinc-500">{label}</span>
        <span className={`text-right ${VALUE_TONE_CLASSES[tone]}`}>{value}</span>
    </div>
);

interface StatListProps {
    children: ReactNode;
    className?: string;
}

/** Vertical container applying consistent spacing between StatRows. */
export const StatList = ({ children, className = '' }: StatListProps) => <div className={`space-y-1.5 ${className}`}>{children}</div>;
